import { render, staticRenderFns } from "./CcStatusPill.vue?vue&type=template&id=3c7129a8&scoped=true"
import script from "./CcStatusPill.vue?vue&type=script&setup=true&lang=js"
export * from "./CcStatusPill.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcStatusPill.vue?vue&type=style&index=0&id=3c7129a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7129a8",
  null
  
)

export default component.exports